import { Datepicker } from 'vanillajs-datepicker';

export const dobInput = () => {
    const elem = document.getElementById('signup_dob');

    if ( elem ) {        
        const date = new Date();
        date.setFullYear( date.getFullYear() - 18 );
    
        const options = {
            autohide: true,
            format: 'dd/mm/yyyy',
            maxDate: date,
            startView: 2
        };
    
        const datepicker = new Datepicker(elem, options);

        return datepicker;
    } else {
        return null;
    }
}